/* mb-offer-code.js v1 - 2026-09-01
   ---------------------------------------------------------------------------------------
   WHY THIS EXISTS. The first-order price is carried by a Shopify discount limited to the
   customer segment "Customers who haven't purchased". Shopify can only evaluate a customer
   segment once it knows who the buyer is, so the AUTOMATIC version of that discount does not
   show in an anonymous cart: the drawer showed the full 25.00 and only dropped to 15.99 after
   an email was typed at checkout. Owner's decision (2026-09-01): show the offer price to
   everyone in the drawer and let a returning customer find out at checkout, rather than show
   a first-time buyer the full price and lose them at the drawer.

   So the FIRSTBUNDLE code is put on the session, which Shopify applies to the cart line
   immediately - no buyer identity needed for a code.

   WHAT IT DOES NOT DO. It does not touch the cart app. No fetch or XMLHttpRequest patching,
   no drawer is opened or re-rendered, no cart event is dispatched, nothing is drawn. It calls
   Shopify's own /discount/ endpoint and reads /cart.js. That is the whole surface.

   THE BUG IT REPLACES. sections/disc-bundle-selector.liquid did the same thing behind a
   sessionStorage flag: applied once, set the flag, never looked again. Once anything dropped
   the discount from the session - cart emptied, session reset - the flag still said "done" and
   the visitor paid 25.00 for the rest of the visit with no way to recover. Here the seed flag
   only covers the empty-cart case; whenever the bundle IS in the cart the condition is the
   CART'S OWN STATE, which cannot go stale.

   RETURNING CUSTOMERS. layout/theme.liquid only loads this file when
   customer == nil or customer.orders_count == 0, so a signed-in repeat customer never runs it.
   A signed-out repeat customer will see 15.99 here and 25.00 at checkout once Shopify has their
   email - that is the trade-off the owner chose, deliberately.

   IF THE BUNDLE VARIANT OR THE CODE CHANGES, update the two constants below.
   --------------------------------------------------------------------------------------- */
(function () {
  if (window.__mbOfferCode) return;
  window.__mbOfferCode = true;

  var VARIANT_ID = 49626946175303; /* myBIANCA Discovery Bundle */
  var CODE = 'FIRSTBUNDLE';
  var SEED_KEY = 'mb_offer_seed_v1';
  var busy = false;

  function applyCode() {
    /* v5.41: redirect to /cart.js (3 kB JSON) instead of the homepage (~300 kB) — the cookie
       is set on the 302 either way. */
    return fetch('/discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent('/cart.js')).catch(function () {});
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var line = null;
        for (var i = 0; i < items.length; i++) {
          if (items[i].variant_id === VARIANT_ID) { line = items[i]; break; }
        }

        /* Bundle not in the cart yet. Seed the session ONCE so the very first add already
           returns the discounted line and the drawer opens on the right price. */
        if (!line) {
          var seeded = false;
          try { seeded = !!sessionStorage.getItem(SEED_KEY); } catch (e) {}
          if (seeded) { busy = false; return; }
          return applyCode().then(function () {
            try { sessionStorage.setItem(SEED_KEY, '1'); } catch (e) {}
            busy = false;
          });
        }

        /* Bundle IS in the cart. If no discount landed on that line, the session lost it -
           re-apply. This branch is what makes the seed flag above safe to keep. */
        var allocations = line.line_level_discount_allocations || [];
        if (allocations.length > 0) { busy = false; return; }
        return applyCode().then(function () { busy = false; });
      })
      .catch(function () { busy = false; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
